import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import {  RequiredAuthProvider, RedirectToLogin } from "@propelauth/react";
import { StyledEngineProvider } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RequiredAuthProvider authUrl={process.env.REACT_APP_AUTH_URL} displayIfLoggedOut={<RedirectToLogin />}>
    <BrowserRouter>
      {/* <StyledEngineProvider injectFirst> */}
        <App />
      {/* </StyledEngineProvider> */}
    </BrowserRouter>
  </RequiredAuthProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
